import PageDescription from 'components/PageDescription';

import {
  toCategoryLink,
  toLandingPageLink,
  toStoreOffersLink,
  toSubcategoryLink,
} from 'lib/links';

import LINKS from 'constants/links';

const TOPICS = [
  {
    title: 'Saiba mais sobre os cupons de desconto Promobit',
    paragraphs: [
      'Você já teve a sorte de encontrar aquele cupom de desconto perfeito para a sua compra, que até fez você comemorar na hora de colocar seus produtos no carrinho? O Promobit sabe como esses pequenos vouchers ajudam na hora do pagamento e, por isso, reunimos para você os melhores códigos promocionais de toda a internet em um só lugar! Aí fica mais fácil comprar o que você precisa por um preço baixo.',
      'Os cupons de desconto funcionam como vouchers promocionais oferecidos por lojas virtuais, garantindo mais vendas e gerando maiores ganhos, tanto para vendedores quanto para clientes. Esses códigos são uma estratégia excelente para realizar boas oportunidades de negócio, pois colaboram para uma maior economia na hora da compra, ao mesmo tempo que incentivam um aumento do volume das vendas e ainda ajudam a fidelizar consumidores. Afinal, quem não fica feliz em ganhar aquele descontinho?',
      'Com os códigos de promoção disponíveis aqui no Promobit, você pode conseguir até 50% de desconto sobre o valor final da sua compra. São diferentes tipos de cupom, que variam de acordo com as promoções oferecidas pelo e-commerce.',
      'Para conseguir o seu desconto especial no nosso site, basta selecionar uma das lojas parceiras para conferir todos os vouchers disponíveis no momento. Será disponibilizado um código da oferta, que deverá ser inserido no local indicado ao finalizar a sua compra, para que o desconto seja abatido sobre o valor final. Ao selecionar a loja, você também poderá ser direcionado para o site e o código pode ser aplicado automaticamente, garantindo o seu desconto com maior praticidade e facilidade.',
    ],
    subtopics: [
      {
        title:
          'Cupons de desconto: saiba quais lojas e marcas são parceiras do Promobit',
        paragraphs: [
          'Para não perder a oportunidade de fazer a melhor compra, é bom ficar atento a alguns pontos. Primeiro, na hora de selecionar o seu cupom, para garantir o desconto, observe se o mesmo ainda está ativo, pois os códigos podem possuir validade. A data poderá ser encontrada nas regras de utilização, bem como outras informações. Outros só garantem o desconto acima de um determinado valor de compra, por isso é importante estar atento às condições da promoção.',
        ],
        subtopics: [
          {
            title: 'Cupom Americanas',
            paragraphs: [
              `A Americanas.com, braço virtual das Lojas Americanas, também é grande adepta de códigos de desconto e está sempre presenteando seus clientes com vouchers novos. Na nossa plataforma, você encontra aquele <a href=${toStoreOffersLink(
                'americanas'
              )}>cupom Americanas</a> para deixar a sua compra com aquele preço baixinho que a gente adora. Um dos códigos bastante oferecidos pela marca é o de frete grátis. Ótimo, não?`,
            ],
          },
          {
            title: 'Cupom Netshoes',
            paragraphs: [
              `A maior vendedora de calçados do Brasil também não deixaria de aproveitar as vantagens que os códigos de desconto oferecem para os seus clientes. Usando um <a href=${toStoreOffersLink(
                'netshoes'
              )}>cupom Netshoes</a> você consegue aquele tênis, sandália ou bota pelo menor preço!`,
            ],
          },
          {
            title: 'Cupom de desconto McDonalds',
            paragraphs: [
              `Também dá para comprar comida por ótimos preços! Com o <a href=${toStoreOffersLink(
                'mcdonalds'
              )}>cupom de desconto McDonalds</a> você garante seu lanche favorito por um preço baratíssimo!`,
            ],
          },
          {
            title: '',
            paragraphs: [
              'Outras lojas com cupons para você aproveitar são: Centauro, Extra, Pontofrio, Nike, Casas Bahia, Carrefour, Walmart, Ricardo Eletro, Marisa, Fast Shop e muitas, muitas outras.',
            ],
          },
        ],
      },
    ],
  },
  {
    title: 'Como usar cupons de desconto para economizar',
    paragraphs: [
      'Utilizados como forma de atrair e fidelizar os clientes, os códigos promocionais ganharam muito mais força com a popularização da internet, que fez com que eles ficassem disponíveis para um número muito mais significativo de consumidores em potencial sem grandes custos.',
      'Quando utilizados de forma correta, os cupons facilitam muito a vida. Mas muitas vezes, seu uso fica muito restrito ou se perde uma boa oferta por não ter entendido todas as condições de uso do voucher.',
      'Para diminuir este risco, listamos os principais aspectos que é preciso ter em mente na hora de utilizar um cupom de desconto.',
    ],
    subtopics: [
      {
        title: 'Tipos de cupom de descontos',
        paragraphs: [
          'Em geral, as lojas virtuais disponibilizam três tipos de cupons promocionais:',
        ],
        subtopics: [
          {
            title: 'Cupons de descontos para todo o site',
            paragraphs: [
              'São aqueles que conferem redução de preço - entre 5% e 15% - de qualquer produto adquirido, independente da seção ou faixa de compra.',
            ],
          },
          {
            title: 'Cupons de desconto para determinada oferta',
            paragraphs: [
              'Esses códigos em geral possuem uma porcentagem maior de desconto - podendo variar entre 20% e 30% - que é válida apenas um determinado produto ou para um departamento específico. Vale procurar por lojas que façam este tipo de oferta para itens que você compra de forma constante, como livros.',
            ],
          },
          {
            title: 'Cupons de desconto sobre a oferta',
            paragraphs: [
              'Este tipo cupom só funciona quando você está para concluir uma compra em determinada loja. Ao adicioná-lo, o valor total será abatido - geralmente, em 10% -, o que pode estimular o cliente e consumir mais produtos.',
            ],
          },
        ],
      },
    ],
  },
  {
    title: 'Diferentes formas de resgate cupons',
    paragraphs: [
      'Cada empresa possui sua própria metodologia para a disponibilização de códigos promocionais. Por isso, é importante conferir como eles podem ser apresentados para ter certeza de que você cumpriu todos os passos para ter direito ao desconto anunciado. Os tipos mais comuns de resgate do cupom são:',
    ],
    subtopics: [
      {
        title: 'Código',
        paragraphs: [
          'Opção adotada pela maioria dos sites, que disponibilizam um código de desconto único e o distribui para seus clientes, indicando-o como uma opção de fácil acesso para a compra de um produto novo na loja virtual.',
        ],
      },
      {
        title: 'Cadastro',
        paragraphs: [
          'Adotada em geral por quem oferece descontos mais expressivos, faz com que o consumidor preencha um cadastro com suas informações antes de disponibilizar o código ou link para o cupom. Como esta opção exige maior dedicação do usuário, geralmente é reservada para a entrega e cupons com descontos mais atraentes.',
        ],
      },
      {
        title: 'Impressão',
        paragraphs: [
          'Quando o cupom dá direito a um brinde físico ou um serviço mais vantajoso, é comum que as lojas virtuais peçam ao cliente para imprimir o voucher e apresentá-lo no dia do resgate do prêmio.',
        ],
      },
    ],
  },
  {
    title: 'Como conseguir cupom de desconto',
    paragraphs: [
      'As lojas costumam disponibilizar seus vouchers de promoção por diversos meios: listas de e-mails, sms para a base de clientes e até pelo próprio site. Mas para você não perder nada, a melhor forma de se manter em dia com todos dos códigos promocionais e acompanhando o Promobit!',
      'Nossa comunidade reúne os melhores códigos de vários varejistas brasileiros em um único lugar, facilitando - e muito - a sua busca pelos melhores preços da internet. Não só isso, nossa equipe de curadores confere cada um deles para ter certeza de que tudo está funcionando corretamente para você!',
    ],
  },
  {
    title: 'Regras para o uso do cupom de desconto',
    paragraphs: [
      '“Não existe almoço grátis” é uma frase que se aplica muito bem ao mundo dos cupons de desconto, pois é importante que o consumidor tenha atenção com as regras de resgate para evitar frustrações.',
      'Abaixo, listamos alguns dos principais fatores que, por falta de conferência, acabam frustrando a aquisição de algum produto e inutilizando o cupom:',
    ],
    subtopics: [
      {
        title: 'Limitação por loja ou horário',
        paragraphs: [
          'A maioria dos cupons tem um prazo muito curto de validade (em muitos casos, apenas algumas horas após sua ativação), por isso vale à pena verificar se seu cupom possui este tipo de restrição e verificar se, mesmo com ela, é possível fazer o resgate do produto desejado.',
        ],
      },
      {
        title: 'Compras atreladas',
        paragraphs: [
          'Em alguns casos, a empresa fornece cupons de desconto para “movimentar” determinada loja ou horário que esteja recebendo um número de clientes abaixo do esperado. Ao conseguir seu código, verifique se ele se enquadra neste caso e se, de acordo com a localização da loja ou horário de validade, vale a pena utilizá-lo.',
          'Alguns cupons de desconto só funcionam caso o consumidor leve algum outro produto ou serviço oferecido pela loja, sendo que muitas vezes o produto já vem mencionado no voucher, sem a possibilidade de substituí-lo por algum produto ou serviço similar. Nestes casos, é importante avaliar a utilidade do cupom ou se vale mais a pena economizar e comprar apenas o produto em separado.',
        ],
      },
    ],
  },
  {
    title: 'Produtos para comprar com cupom',
    paragraphs: [
      'Você pode aproveitar seus códigos promocionais para conseguir aquele acessório ou item que você tanto deseja por um preço que cabe tranquilamente no seu bolso. E tudo isso com a tranquilidade na hora da compra que só a comunidade Promobit oferece.',
      'Vejo alguns tipos de produto que você pode aproveitar com um código de desconto:',
    ],
    subtopics: [
      {
        title: 'Cupom smartphone',
        paragraphs: [
          `Nós sabemos que os modelos mais queridinhos do mercado podem vir com um preço um tanto salgado. Para tornar as coisas mais doces, nós selecionamos aqueles códigos que vão deixar o preço do smartphone do jeitinho que você quer e conseguir comprar aquele, <a href=${toCategoryLink(
            'smartphones-tablets-e-telefones'
          )}>celular barato.</a>`,
        ],
      },
      {
        title: 'Cupom TV',
        paragraphs: [
          `Televisões de diversos tipos também podem ter aquele corte no preço, se você souber qual código utilizar na hora da sua compra e aproveitar as <a href=${toSubcategoryLink(
            'tv'
          )}>promoções de TV.</a>`,
        ],
      },
      {
        title: 'Cupom notebook',
        paragraphs: [
          `Notebooks também não são baratos, mas encontrar promoções e códigos de descontos para o modelo que você deseja é muito mais fácil do que parece: é só contar com a ajuda do Promobit! Às vezes, um simples frete grátis pode ajudar na hora de fazer seu pagamento e diminuir ainda mais o preço conseguido naquela <a href=${toSubcategoryLink(
            'notebooks'
          )}>promoção de notebook.</a>`,
        ],
      },
      {
        title: 'Cupom Black Friday',
        paragraphs: [
          `A <a href=${toLandingPageLink(
            'black-friday'
          )}>Black Friday,</a> o maior evento de promoções do mundo, é um prato cheio para quem procura ofertas e descontos. Não deixe de ficar de olho na seleção de vouchers aqui do Promobit para aproveitar a data do melhor jeito!`,
        ],
      },
    ],
  },
  {
    title: 'No Promobit você encontra os melhores cupons de desconto',
    paragraphs: [
      'Além de oferecer as melhores ofertas disponibilizadas pelas principais lojas virtuais do Brasil, o Promobit realiza parcerias com diversos endereços para disponibilizar cupons promocionais aos seus usuários.',
      'Na área de cupons do Promobit, você tem acesso a relação de todas as lojas parceiras, confere um resumo de cada uma delas e visualiza na hora os cupons ativos e o processo de resgate.',
      `Caso exista um cupom que você deseje muito, você também pode monitorá-lo pelo <a href=${LINKS.LANDING_APPS}>app de promoções</a> do Promobit, acessando a área Lista de Desejos e inserindo uma descrição do código desejado.`,
    ],
  },
];

const CouponsPageDescription = () => (
  <PageDescription
    className="bg-transparent dark:bg-transparent"
    pageDescription={TOPICS}
  />
);

export default CouponsPageDescription;
